<div class="or-p-32-px">
  <div class="or-d-flex or-justify-content-center">
    <span class="or-head-xl or-mb-16-px or-text-align-center">Usuń konto</span>
  </div>

  @if (authProviderId() === AuthProviderId.Password) {
    <div class="or-d-flex or-justify-content-center or-text-align-center or-mb-20-px">
      <span class="or-text-md">Podaj hasło, aby potwierdzić usunięcie konta.</span>
    </div>
    <form [formGroup]="passwordForm" class="or-mb-24-px">
      <or-input-with-icon
        placeholder="Hasło"
        formControlName="password"
        [type]="showPassword() ? 'text' : 'password'"
        [icon]="showPassword() ? 'assets/icons/v2/eye-off.svg' : 'assets/icons/v2/eye.svg'"
        (iconClick)="toggleShowPassword()" />
    </form>
  } @else if (authProviderId() === AuthProviderId.Google) {
    <div class="or-d-flex or-justify-content-center or-text-align-center or-mb-24-px">
      <span class="or-text-md">Aby usunąć konto, potwierdź swoją tożsamość logując się ponownie przez Google.</span>
    </div>
  } @else if (authProviderId() === AuthProviderId.Apple) {
    <div class="or-d-flex or-justify-content-center or-text-align-center or-mb-24-px">
      <span class="or-text-md">Aby usunąć konto, potwierdź swoją tożsamość logując się ponownie przez Apple.</span>
    </div>
  }

  <div class="or-d-flex">
    <button class="button-secondary-style or-h-48-px or-w-60-pc or-head-sm or-mr-8-px" (click)="closeModal()">
      Anuluj
    </button>
    <button
      class="button-primary-style or-h-48-px or-w-60-pc or-head-sm or-color-white"
      [disabled]="isConfirmDisabled()"
      [class.disabled-button]="isConfirmDisabled()"
      (click)="confirm()">
      {{ authProviderId() === AuthProviderId.Password ? 'Usuń konto' : 'Potwierdź i usuń konto' }}
    </button>
  </div>
</div>
